export const LEGACY_BACKEND_MESSAGES = {
  auth_not_authenticated: 'User is not authenticated or is not an authorized user.',
  auth_permission_denied_add_org: 'User does not have permission to add organisation.',
  payload_missing_required_fields: 'Missing required fields.',
  organisation_invalid_type: 'Invalid organisation type.',
  organisation_duplicate_owner_name: 'Organisation already exists.',
  organisation_create_failed: 'Failed to create new organisation.',
  organisation_set_claims_failed_user: 'Failed to set custom claims for user.',
  onboarding_not_new_user: 'User is not a new user.',
  onboarding_unknown_error: 'Unknown error occurred while creating the invited user.',
  email_invalid_argument: 'The function must be called with a valid email address.',
  email_already_verified: 'Email is already verified.',
  email_no_data: 'No email data found.',
  email_sending_failed: 'Error sending email.',
  email_verification_failed: 'Failed to send new verification email.',
  password_strength_failed: 'Password does not meet strength requirements. It must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
  invitation_invalid_token: 'Invalid or expired invitation token.',
  invitation_not_found: 'Invitation not found.',
  invitation_not_pending: 'Invitation is not in pending status.',
  invitation_missing_id: 'Invalid or missing invitation ID.',
  invitation_public_cancel_denied: 'Public invitations cannot be canceled.',
  invitation_not_inviter: 'User is not the inviter of this invitation.',
  invitation_not_inviter_or_delegate: 'User is not the inviter or delegate of this invitation.',
  invitation_promoter_not_public: 'Invalid promoter or the promoter is not allowing public invitations.',
  promoter_not_found: 'Promoter does not exist',
  promoter_missing_claims: 'Promoter does not have custom claims',
  invitation_invalid_email_format: 'Invalid email or password format.',
  invitation_invalid_role_division: 'Invalid role or division.',
  invitation_already_accepted: 'The invited email has an accepted invitation already.',
  invitation_email_in_use: 'The invited email is already used in the system.',
  invitation_create_failed: 'Failed to create new invitation.',
  invitation_create_user_failed: 'Failed to create new user.',
  invitation_create_user_ref_failed: 'Failed to create new user ref.',
  invitation_inviter_data_failed: 'Failed to get inviter user data.',
  invitation_inviter_claims_failed: 'Failed to get inviter user customClaims.',
  invitation_custom_claims_too_large: 'Custom claims object exceeds size limits.',
  invitation_invite_permission_denied: 'User does not have permission to invite users.',
  invitation_fetch_failed: 'Error fetching invitations.',
  invitation_user_missing_email: 'Authenticated user does not have an email.',
  invitation_owner_missing: 'owner does not exist',
  invitation_role_not_authorized: 'Role unothorized.',
  invitation_role_not_found: 'Role does not exist.',
  invitation_pending_exists: 'Invitation already in progress.',
  organisation_not_found: 'Organization does not exist.',
  organisation_add_failed: 'Failed to add organisation.',
  invitation_cancel_unknown: 'Unknown error occurred while canceling invitation.',
  invitation_reject_unknown: 'Unknown error occurred while rejecting invited user.',
  invitation_request_unknown: 'Unknown error occurred while requesting invitation.',
  verify_email_unknown: 'Unknown error occurred while verifying email.',
  superuser_unauthorized: 'Unauthorized access attempt, only superusers can access this action.',
  superuser_invitations_unknown: 'Unknown error occurred while retrieving invitations.',
  superuser_users_unknown: 'Unknown error occurred while retrieving users.',
  superuser_organisations_unknown: 'Unknown error occurred while retrieving organizations.',
  signup_requires_auth: 'The function must be called while authenticated.',
  signup_unknown_error: 'Unknown error occurred while creating new owner.',
  signup_update_password_failed: 'Failed to update user password.'
} as const;

export type LegacyBackendMessageKey = keyof typeof LEGACY_BACKEND_MESSAGES;
